export const LearnerActivityReportTypeEnum = Object.freeze(
   {
      ActiveLearners:0,
      InactiveLearners:1,
      EnrolledLearners:2,   })

   export const LearnerActivityReportTypeEnumLabel = Object.freeze({
      [LearnerActivityReportTypeEnum.ActiveLearners] : "ActiveLearners",
      [LearnerActivityReportTypeEnum.InactiveLearners] : "InactiveLearners",
      [LearnerActivityReportTypeEnum.EnrolledLearners] : "EnrolledLearners",
      
      
   })

   export const LearnerInactivityPeriodEnum = Object.freeze(
   {
      Last7Days : 7,
      Last30Days : 30,
      Last60Days : 60,
      Last90Days : 90
   })

   export const SortDirectionEnum = Object.freeze(
  {
     Ascending:0,
     Descending:1
  })